import React, { FC, useMemo, useState } from 'react';

import './styles.scss';

export type BingoFilterValue = string;

type BingoFilterProps = {
  options: readonly string[];
  initial?: BingoFilterValue;
  onChange?: (value: BingoFilterValue) => void;
};

export const BingoFilter: FC<BingoFilterProps> = ({ options, initial = 'ALL', onChange }) => {
  const normalizedInitial = useMemo(
    () => (options.includes(initial) ? initial : options[0] || 'ALL'),
    [initial, options]
  );
  const [value, setValue] = useState<BingoFilterValue>(normalizedInitial);

  const handleClick = (next: BingoFilterValue): void => {
    setValue(next);
    onChange?.(next);
  };

  return (
    <div className="bingo-filter">
      {options.map((option) => (
        <button
          type="button"
          key={option}
          className={`bingo-filter__option ${option === value ? 'bingo-filter__option--active' : ''}`}
          onClick={(): void => handleClick(option)}
        >
          {option}
        </button>
      ))}
    </div>
  );
};
